<template>
    <div class="container-fluid px-0">
        <div class="row" v-if="!loadingComentarios">
            <div class="col-12">
                <h4 class="font-weight-bold">{{ label || "Comentários" }}</h4>
            </div>
        </div>
        <div class="row" style="overflow-y: auto; overflow-x: hidden">
            <load
                mode="table"
                v-if="loadingComentarios"
                message="Aguarde, estamos verificando se existem comentários."
            />
            <comentarios
                v-else
                :comentarios="comentarios"
                @scroll="scrollTopFormComentario"
                :reply="true"
                :showCommentForm="showCommentForm"
            />
        </div>
        <div v-if="showCommentForm !== false">
            <load mode="table" v-if="sendComentario" />
            <div
                v-else
                class="row px-3 d-flex justify-content-end"
                id="form-comentario"
            >
                <div
                    class="col-12 alert alert-secondary m-0"
                    v-if="textResponder != ''"
                    v-html="textResponder"
                ></div>
                <form-textarea-editor v-model="descricao" class="px-0" />
                <div class="col-auto px-0 text-right">
                    <button
                        class="btn mx-0 mb-3 btn-primary btn-submit"
                        @click="submit"
                    >
                        <i class="mdi mdi-message-reply" />
                        {{ textButton }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        model: String,
        module: String,
        id: [String, Number],
        label: String,
        textoBotao: String,
        showCommentForm: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            comentarios: {},
            descricao: "",
            sendComentario: false,
            loadingComentarios: true,
            comentario_pai: "",
            textButton: this.textoBotao || this.$t("Comentar"),
            textResponder: "",
            moduleName: this.module,
            modelName: this.model,
            atividadeid: this.id
        };
    },
    created() {
        this.getComentarios();
    },
    methods: {
        getComentarios() {
            var model = this.modelName || this.moduleName;
            
            axios
                .get(`api/dashboard/get/comentarios`, {
                    params: {
                        id: this.atividadeid,
                        module: this.moduleName,
                        model: model,
                    }
                })
                .then((response) => {
                    this.comentarios = response.data.data;
                })
                .finally(() => {
                    this.loadingComentarios = false;
                });
        },
        scrollTopFormComentario(comentario) {
            this.textButton = this.$t("Responder");
            this.textResponder = `Digite sua resposta ao comentário feito por: <b>${comentario.usuario.name}</b>`;
            this.comentario_pai = comentario.id;
            var elemento = document.getElementById("form-comentario");
            window.scrollTo({
                top: elemento.offsetTop,
                left: elemento.offsetLeft,
                behavior: "smooth",
            });
        },
        submit() {
            if (this.descricao != "") {
                this.sendComentario = true;
                axios
                    .post("/api/dashboard/comentarios", {
                        mensagem: this.descricao,
                        comentario_pai: this.comentario_pai,
                        model: this.model,
                        module: this.module || this.model,
                        id: this.id,
                    })
                    .then((response) => {
                        this.$snack.success({
                            button: false,
                            text: "Seu comentário foi salvo com sucesso.",
                        });
                        this.comentarios = response.data.data;
                        this.descricao = "";
                        this.descricao = "";
                        this.textResponder = "";
                        this.textButton = this.$t("Comentar");
                    })
                    .finally(() => {
                        this.sendComentario = false;
                    });
            }
        },
    },
};
</script>
